import NotificationsForm from './NotificationsForm';

export default NotificationsForm;
